import { createStrokePatternsContext } from './stroke-patterns-context-factory';

const { StrokePatternsContext, useStrokePatternsContext } = createStrokePatternsContext(
  'RunsStrokePatternsContextProvider',
);

export const RunsStrokePatternsContext = StrokePatternsContext;
export const useRunsStrokePatternsContext = useStrokePatternsContext;
